import { useTranslation } from "react-i18next";
import { ReactComponent as NoJourneyImage } from "../../images/noJourney.svg";
import { MyDashboardMode } from "../../types/dtos/users/SignedInUserDto";

interface JourneyEmptyStateProps {
  /** Whether or not the user has any (form summary) tabs displayed on their dashboard */
  userSummaryTabCount: number;
  userStatus: MyDashboardMode;
}

function JourneyEmptyState({
  userSummaryTabCount,
  userStatus,
}: JourneyEmptyStateProps) {
  const { t } = useTranslation();

  const showTabHint = userStatus === "STANDARD" && userSummaryTabCount > 0;
  const tabHint =
    userSummaryTabCount === 1
      ? t(
          "Journey.EmptyState.ClickOnTab",
          "Click on the tab below to update your journey",
        )
      : t(
          "Journey.EmptyState.ClickOnOneOfTheTabs",
          "Click on one of the tabs below to update your journeys",
        );

  return (
    <div
      role="status"
      aria-labelledby="journey-empty-state-title"
      className="mx-auto flex max-w-md flex-col items-center gap-3 px-2 py-2 text-center"
    >
      <NoJourneyImage
        className="mx-auto h-24 w-auto"
        aria-hidden="true"
      />
      <h3
        id="journey-empty-state-title"
        className="light-heading !mb-0 !text-white text-balance"
      >
        {t("Journey.EmptyState.NoQuestionsAtThisTimeTitle", "All quiet here")}
      </h3>
      <p className="text-pretty text-sm text-white/90">
        {t(
          "Journey.EmptyState.NoQuestionsAtThisTime",
          "There are no questions to answer at this time",
        )}
      </p>
      {showTabHint && (
        <p className="text-sm text-white/75">{tabHint}</p>
      )}
    </div>
  );
}

export default JourneyEmptyState;
